export type FeaturesProps = {
  canAccessApplicationsOnMFFeedConnect: boolean;
  canAccessDashboardRentalProtection: boolean;
  canAccessDeactivationRedesign: boolean;
  canAccessModularListing: boolean;
  canEditMFFeedContact: boolean;
  canAccessRentalProtectionFromML: boolean;
  metroidIframeButtonText: string;
  canAccessFastPost: boolean;
  canAccessManagePolicyPageV2: boolean;
  canAccessRentalProtectionLightweightOptin: boolean;
  canAccessRentalProtectionFuturePolicyCancellation: boolean;
  canAccessListingPreview: boolean;
  canAccessNoWelcomePageML: boolean;
  canAccessPostActivationWorkflow: boolean;
  maxBuildIncrementLimit: number;
  canAccessHousingConnector: boolean;
  propertiesPageV1AccessPercent: number;
  canAccessSubmitRequestWidget: boolean;
  canAccessNewSupportForm: boolean;
  canAccessLandingPageMonetization: boolean;
  canAccessZRMMarketingComponents: boolean;
  canAccessB2BLayout: boolean;
  isBoostAdsConfigEnabled: boolean;
  canPostForSaleListing: boolean;
  canAccessTenantModule: boolean;
  tenantModuleStates: string;
  canAccessProofOfInsuranceModule: boolean;
  canAccessTotalMonthlyPriceWithFee: string;
  canAccessSteppedFee: boolean;
  brokerFeeAlertStates: string;
  canEditTourDuration: boolean;
  canAccessPostingPathTourDuration: boolean;
  canAccessUpdatedTotalMonthlyPriceCopy: boolean;
  canAccessSpotlightListing: boolean;
  pandaTheme: string;
};

export type ConfigProps = {
  features: FeaturesProps;
};

export type AppConfigProps = {
  config: ConfigProps;
};

const Features = ({
  canAccessApplicationsOnMFFeedConnect = false,
  canAccessDashboardRentalProtection = false,
  canAccessDeactivationRedesign = false,
  canAccessModularListing = false,
  canEditMFFeedContact = false,
  canAccessRentalProtectionFromML = false,
  metroidIframeButtonText = '',
  canAccessFastPost = false,
  canAccessManagePolicyPageV2 = false,
  canAccessListingPreview = false,
  canAccessRentalProtectionLightweightOptin = false,
  canAccessNoWelcomePageML = false,
  canAccessPostActivationWorkflow = false,
  maxBuildIncrementLimit = 10,
  canAccessRentalProtectionFuturePolicyCancellation = false,
  canAccessHousingConnector = false,
  propertiesPageV1AccessPercent = 0,
  canAccessSubmitRequestWidget = false,
  canAccessNewSupportForm = false,
  canAccessLandingPageMonetization = false,
  canAccessZRMMarketingComponents = false,
  canAccessB2BLayout = false,
  isBoostAdsConfigEnabled = false,
  canPostForSaleListing = false,
  canAccessTenantModule = false,
  tenantModuleStates = '',
  canAccessProofOfInsuranceModule = false,
  canAccessTotalMonthlyPriceWithFee = 'false',
  canAccessSteppedFee = false,
  brokerFeeAlertStates = '',
  canEditTourDuration = false,
  canAccessPostingPathTourDuration = false,
  canAccessUpdatedTotalMonthlyPriceCopy = false,
  canAccessSpotlightListing = false,
  pandaTheme = '',
}: Partial<FeaturesProps> = {}): FeaturesProps => ({
  canAccessApplicationsOnMFFeedConnect: Boolean(canAccessApplicationsOnMFFeedConnect),
  canAccessDashboardRentalProtection: Boolean(canAccessDashboardRentalProtection),
  canAccessDeactivationRedesign: Boolean(canAccessDeactivationRedesign),
  canAccessModularListing: Boolean(canAccessModularListing),
  canEditMFFeedContact: Boolean(canEditMFFeedContact),
  canAccessRentalProtectionFromML: Boolean(canAccessRentalProtectionFromML),
  metroidIframeButtonText: String(metroidIframeButtonText),
  canAccessFastPost: Boolean(canAccessFastPost),
  canAccessManagePolicyPageV2: Boolean(canAccessManagePolicyPageV2),
  canAccessListingPreview: Boolean(canAccessListingPreview),
  canAccessRentalProtectionLightweightOptin: Boolean(canAccessRentalProtectionLightweightOptin),
  canAccessNoWelcomePageML: Boolean(canAccessNoWelcomePageML),
  canAccessPostActivationWorkflow: Boolean(canAccessPostActivationWorkflow),
  maxBuildIncrementLimit: Number(maxBuildIncrementLimit),
  canAccessRentalProtectionFuturePolicyCancellation: Boolean(canAccessRentalProtectionFuturePolicyCancellation),
  canAccessHousingConnector: Boolean(canAccessHousingConnector),
  propertiesPageV1AccessPercent: Number(propertiesPageV1AccessPercent),
  canAccessNewSupportForm: Boolean(canAccessNewSupportForm),
  canAccessSubmitRequestWidget: Boolean(canAccessSubmitRequestWidget),
  canAccessLandingPageMonetization: Boolean(canAccessLandingPageMonetization),
  canAccessZRMMarketingComponents: Boolean(canAccessZRMMarketingComponents),
  canAccessB2BLayout: Boolean(canAccessB2BLayout),
  isBoostAdsConfigEnabled: Boolean(isBoostAdsConfigEnabled),
  canPostForSaleListing: Boolean(canPostForSaleListing),
  canAccessTenantModule: Boolean(canAccessTenantModule),
  tenantModuleStates: String(tenantModuleStates),
  canAccessProofOfInsuranceModule: Boolean(canAccessProofOfInsuranceModule),
  canAccessTotalMonthlyPriceWithFee: String(canAccessTotalMonthlyPriceWithFee),
  canAccessSteppedFee: Boolean(canAccessSteppedFee),
  brokerFeeAlertStates: String(brokerFeeAlertStates),
  canEditTourDuration: Boolean(canEditTourDuration),
  canAccessPostingPathTourDuration: Boolean(canAccessPostingPathTourDuration),
  canAccessUpdatedTotalMonthlyPriceCopy: Boolean(canAccessUpdatedTotalMonthlyPriceCopy),
  canAccessSpotlightListing: Boolean(canAccessSpotlightListing),
  pandaTheme: String(pandaTheme),
});

const Config = ({ features }: Partial<ConfigProps> = {}): ConfigProps => ({
  features: Features(features),
});

// only expose config property
// keeping the data model the same structure as response
// in order to easily add other properties
const AppConfig = ({ config }: Partial<AppConfigProps> = {}): AppConfigProps => ({
  config: Config(config),
});

export { Features };

export default AppConfig;
